import * as React from "react"
const SvgEducation = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.05 18.06a2 2 0 0 1-.775-.737A2 2 0 0 1 5 16.286v-4.8L2.6 10.16a.97.97 0 0 1-.4-.375 1 1 0 0 1-.125-.5q0-.275.125-.5a.97.97 0 0 1 .4-.375l8.45-4.6a1.9 1.9 0 0 1 1.438-.188q.237.063.462.188l9.525 5.2a.9.9 0 0 1 .387.362q.138.239.138.513v6.4q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712v-5.9l-2 1.1v4.8q0 .575-.275 1.037a2 2 0 0 1-.775.738l-5 2.7a1.9 1.9 0 0 1-1.438.188 2 2 0 0 1-.462-.188zM12 12.987l6.85-3.7-6.85-3.7-6.85 3.7zm0 6.025 5-2.7v-3.775l-4.025 2.225a2.06 2.06 0 0 1-1.475.188 2 2 0 0 1-.475-.188L7 12.536v3.775l5 2.7Z" />
  </svg>
)
export default SvgEducation
